import axiosInstance from "../api";

const TOKEN = 'token';
const REFRESH_TOKEN = 'refresh_token';
const TOKEN_ISSUED_AT = 'token_issued_at';

/**
 * `issuedAt` exists so a refresh that never reached Core can put the previous
 * token back without moving its age forward. Pass it only when restoring; a
 * genuinely new token is stamped now.
 */
export const saveToken = (token, issuedAt = Date.now()) => {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem(TOKEN, token);
    localStorage.setItem(TOKEN_ISSUED_AT, String(issuedAt));
}

/**
 * The stored access token without touching the axios defaults, unlike loadToken().
 */
export const peekToken = () => {
    return localStorage.getItem(TOKEN);
}

export const loadToken = () => {
    const token = localStorage.getItem(TOKEN);
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return token;
}

export const clearToken = () => {
    delete axiosInstance.defaults.headers.common["Authorization"];
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(TOKEN_ISSUED_AT);
}

/**
 * When the stored access token was last issued, as epoch milliseconds, or 0 when
 * that is unknown. Used to decide whether a session is stale enough to be worth
 * spending the refresh token on.
 *
 * This must track when Core *issued* the token, not when the app last wrote it to
 * storage. Re-stamping it on every start would let a terminal that restarts more
 * often than the staleness window (an error-boundary reload, a PWAUpdater version
 * reload) look permanently fresh and never renew.
 */
export const loadTokenIssuedAt = () => {
    return Number(localStorage.getItem(TOKEN_ISSUED_AT)) || 0;
}

export const saveRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
}

export const loadRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
}

export const clearRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
}